import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import MailIcon from '../../assets/images/mail.png';
import { CustomButton, ShowMessage } from '../../components';
import { Flex } from 'antd';
import { capitalize } from '../../common/helper';
import { getThemeAccentColor } from '@/utils/themeColor';

interface LocationState {
  email?: string;
  name?: string;
}

const VerifyEmail: React.FC = () => {
  const location = useLocation();
  const [state] = useState<LocationState>(location.state || {});
  const [isFormValid] = useState<boolean>(true);
  const { email, name } = state;

  const resendEmail = (): void => {
    //need implementation
  };
  const themeColor = getThemeAccentColor();

  return (
    <>
      <Flex
        vertical={true}
        align='center'
        justify='center'
        className='zl-verify-email'
      >
        <ShowMessage
          heading='Verify your email address'
          text={`Thanks${name ? `, ${capitalize(name)}` : ''}. We’ve emailed you a link${email ? ` at ${email}` : ''} to verify your email and set up your password.`}
          icon={MailIcon}
          themeColor={themeColor}
        ></ShowMessage>
        <CustomButton
          isFormValid={isFormValid}
          text='Resend email'
          onClick={resendEmail}
          fontWeight='500'
          fontSize='16'
          lineHeight='20px'
          color='var(--text-primary)'
          height='48px'
          width='133px'
          borderRadius='8px'
          bgColor='var(--light-gray)'
        />
      </Flex>
    </>
  );
};

export default VerifyEmail;
